import pako from "pako";
import { StylesFilter, StylesFilter_Blazer, StylesFilter_kurta } from "../Data"
import { db } from "../firebase"
import { addData } from "../Firebase/firestore"
import { getData, getDatafromDoc } from "../Firebase/firestoreGet"
//import { compress, compressToEncodedURIComponent, compressToUTF16, decompress, decompressFromEncodedURIComponent, decompressFromUTF16 } from 'lz-string';
import { compress, decompress, strToU8, u8ToStr } from 'fflate';
import { Types } from "../Data"
const backendURL = "https://suits-backend.vercel.app"
// const backendURL = "http://localhost:1337"

export const AppointReq = async(data)=>{
    try{
        const headers = {
            "Content-Type" : "application/json"
        }        

        
        
        const collection = db.collection("Users").doc("Requests").collection(data["email"])
        await addData(collection, "", data);
        const resp = await fetch(`${backendURL}/appointment`, {method : 'POST',headers:headers,body:JSON.stringify(data)})
        const res = await resp.json()

        return res.status === 0 ? true : false
    }catch(e){
        console.log(e)
    }
}


export const senEmail = async (params)=>{
        
    const headers = {
        "Content-Type" : "application/json"
    }
    const resp = await fetch('https://suits-backend.onrender.com/sendMail', {method : 'POST',headers:headers,body:JSON.stringify(params)})
    const res = await resp.json()

    return res.status === 0 ? true : false


}


export const postOrder = async(order)=>{

    try{
        console.log("POST Order")

        let orders = JSON.parse(localStorage.getItem('sel'))

        var address = JSON.parse(localStorage.getItem('a'))

        address = address["delivery"]
        

        console.log("Orders" , orders)

        if(orders){ 
            // // console.log("Checking order details",order)
            for(let i = 0;i<orders.length;i+=1){
                orders[i]["payment_order_id"] = order["razorpay_order_id"]
                orders[i]["payment_id"] = order["razorpay_payment_id"]
                orders[i]["Address"] = address
                orders[i]["status"] = { status:0, Date : new Date() }
            }
            // console.log("dumping in DB", orders)
            
            const collection = db.collection('Orders')
            var batch = db.batch();
            // console.log("passing this")
            const email = order.email
            const curr = new Date()

            const OrderID = curr.getTime().toString()+"M"
            var i = 0
            orders.forEach((doc) => {
                i = i+1
                const ID = (new Date().getTime()).toString()
                // console.log("ID from orders, ", ID)
                const finalOrder = {...doc, ...{"Date":Date(), "id":ID, "email":email, "orderId":OrderID}}
                batch.set(collection.doc(ID), finalOrder);
            })
            const result = await batch.commit()
            
            // paymentStatus({...payment, "id":1})

            localStorage.removeItem('sel')
            localStorage.removeItem('a')

            const pramsData = {
                "email" : email,
                "name" : address.name,
                "orderId" :  OrderID ,
                "items" : i.toString(),
                "price" : order["price"]
            }
            // setcheck({...checkoutData, ...pramsData})
            
            console.log("User Detaisl", pramsData)
            
            senEmail(pramsData).then(()=>{})
            // setLoading(false)
            // console.log("postOrder", result)

            return {...pramsData, ...{status: 1 } }
        }else{
            // console.log("No orders")
            // paymentStatus({...payment, "id":-1})
            // return error
            return {status: 0 } 
        }
    } catch(e){
        return {status: 0 } 
        // console.log("Error",e)
        // paymentStatus({...payment, "id":-1})
    }
}


export const paymentVerification = async(response, atype = 0)=>{
    try{
        // console.log("Verification : ", response)
        const params = {
            "razorpay_payment_id": response.razorpay_payment_id,
            "razorpay_order_id": response.razorpay_order_id
        }
        const headers = {
          "x-razorpay-signature":  response.razorpay_signature,
          "Content-Type" : "application/json"
        }

        const options = {
            method : 'POST'
        }
        
        
        const resp = await fetch(`${backendURL}/verification`, {method : 'POST', headers:headers, body:JSON.stringify(params)})
        const res = await resp.json()
        
        return {...res, ...params};
        // console.log("after payent",res)
        // console.log("Payment Status : ", {
        //     "id" : 0, 
        //     "status": res["status"] === 200
        // })
        // paymentStatus({
        //     "id" : 0, 
        //     "status": res["status"] === 200
        // })
        
        
    }catch(e){
        // console.log("verification e", e)
    }
}


export const checkCategory =(category)=> {
    if(category === "suit" || category === "kurta"){
        return true
    } else {
        return false
    }
}

export const changeImgState = (sel, type, pos, setImgState, setLoad, category, imgState, style)=>{
    try{
        var l = 0;

        if(!checkCategory(category)){
            if(category === "formal"){
                if(type === "Shirt"){

                    if(pos === "F"){
                        if(imgState !=0 || style === "Cuffs"){
                            setImgState(1)
                            setLoad(false)
                        } else{
                            l = 1;
                        }
                        
                    }else{
                        setImgState(2)
                        setLoad(false)
                    }
                } else {
                    if(pos === "F"){
                        if(imgState !== 0){
                            setImgState(3)
                            setLoad(false)
                        } else {
                            l=1;
                        }
                        
                    }else{
                        setImgState(4)
                        setLoad(false)
                    }
                    
                }
            } else if (category === "blazer"){
                
                if(pos === "F"){
                    // if(imgState === 0){
                    
                    setImgState(imgState ===2 ? 1 : imgState)
                    l = 1;
                    // }
                    // setImgState(1)
                } else {
                    setImgState(2)
                }
                
            } else if(category === "sadri"){
                l = 1;
            }
            else {
                if(pos && pos === "F"){
                    setImgState(1)
                    setLoad(false)
                }else {
                    setImgState(2)
                    setLoad(false)
                }
            }
            
            
        } else{
            
            if(category === "suit"){
                if(type === "Coat"){

                    if(pos === "F"){
                        if(imgState !== 1){
                            setImgState(0)
                        }
                                                     
                    } else {
                        setImgState(2)
                    }   
                    setLoad(false)
                }
                if(type === "Shirt"){
                    // setLoad(true)
                    setImgState(3)
                    setLoad(false)                                                          
                }
                
                if(type === "Vest"){
                    // setLoad(true)
                    var i = 0
                    if(sel && sel.types && sel.types.includes("Shirt")){
                        i = 6
                    }else{
                        i = 5
                    }
                    setImgState(i)
                    setLoad(false) 
                }
    
                if(type === "Pant"){
                    var i = 0
                    if(sel && sel.types && sel.types.includes("Shirt")){
                        i = 4
                    }else{
                        i = 3
                    }
                    // setLoad(true)
                    if(pos === "F"){
                        setImgState(i)                                                        
                    } else {
                        setImgState(i+1)
                    }
                    setLoad(false)   
                }
            } else if( category === "kurta" ){
                if(type === "Pajama"){
                    if(imgState <=0 && style === "Style"){
                        l = 1;
                    }
                    else if(sel.types.includes("Coat")){
                        if(imgState === 4){
                            l = 1;
                        } else {
                            setImgState(4)
                        }
                        // setLoad(false)
                    } else if(sel.types.includes("Sadri")){
                        if(imgState === 2){
                            l = 1;
                        } else {
                            setImgState(2)
                        }
                    } else {
                        if(imgState === 2){
                            l = 1;
                        } else {
                            setImgState(2)
                        }
                        
                    }
                }
                if(type === "Kurta"){
                    if(imgState === 0 || imgState === 1){
                        if(style === "Cuff Style" && imgState === 0){   
                            setImgState(1)
                        } else {
                            l = imgState + 1 // should only work for 0
                        }
                        
                    } else if(imgState <0 && 
                        ( (style === "Sleeve" && sel.types.includes("Sadri"))
                            || style === "Bottom Cut")
                        ){
                            l = 1;
                    }
                    else{
                        if(style === "Cuff Style"){
                            setImgState(1)
                        } else{
                            setImgState(0)
                            l = 1;
                        }
                        // setLoad(false)
                    }
                    
                }
                if(type === "Coat" || type === "Sadri"){
                    
                    if(imgState === -1 || 
                        (imgState === 2 && type === "Coat") 
                        || (imgState === 3 && type === "Coat") 
                    ){
                        
                        if( ( imgState === -1 || imgState === 2) && pos === "B"){  
                            setImgState(3)
                        }
                        if(imgState === 3 && pos === "F" && type === "Coat"){
                            setImgState(2)
                        }
                        if(imgState === -1 && pos != "B"){
                            l =1 
                        }
                        // l = imgState + 2 // should only work for -1;
                    } else {
                        if(pos === "F"){
                            if(type === "Sadri"){
                                setImgState(3)
                                l=1
                            } else{
                                setImgState(2)
                            }
                            
                        } else {
                            setImgState(3)
                        }
                    }
                }
            }
        
            
        }

        return l;
    } catch(e){ 
        console.log("From changeImgState function", e)
    }
}

export const checkStyleConditions=(sel, value, jodh=null, val1 = null)=>{
    try{    
        
        let condition = false
        const styleF = sel.style[value.name].F
        const styleB = sel.style[value.name].B

        if(value.name === "Kurta"){
            
            if((value.type === "Pocket Type" && styleF[2] === "00")
                || (value.type === "Flap Type" && styleF[4] === "0")
                || (value.type === "Cuff Style" && styleF[8] === "SN")
                || (value.type.includes("Flap") && styleF[2] === "00" )
                || ( ["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS4", "QS4"].includes(val1?.value) )
                || ( !["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS3", "QS3"].includes(val1?.value) )
                || (value.type === "Neck Placket" && ["QS_SP", "NS_SK"].includes(val1?.value) && !["S", "P_S", "QS_S"].includes(styleF[10]) )
                || (value.type === "Neck Placket" && ["NS", "QS"].includes(val1?.value) && ["S", "P_S", "QS_S"].includes(styleF[10]) )
                || ( value.type === "Length" && ["P_S", "QS_S"].includes(val1?.value) && !["S", "P_S", "QS_S"].includes(styleF[10]) )
            ){
                condition = true
            } 
        }
        if(value.name === "Pajama"){

            if(value.type === "Belt" && styleF[0] === "PP"){
                condition = true;
            }
        }

        if(value.name === "Coat"){
            if(value.type === "Stitch" && val1.value === "Y" && styleF[0][0] === "J"){
                condition = true;
            }
            if((value.type === "Lapel" || value.type === "Pocket" ) && styleF[0][0] === "J" ){
                condition = true;
            }
        }
        if(condition) {return condition}


        condition = (jodh && value["type"]=== "Lapel") 
        || (jodh && value["name"] === "Tuxedo")
        || (jodh && value["type"] === "Front Pocket" && val1?.value === "R") 
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && sel.style.Pant.F[2] === "G" )
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-SP")
        || (value["type"] === "Belt Style" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && val1?.value === "G" &&  sel.style.Pant.F[1] === "R")
        || ( value["type"] === "Cuffs" && sel.style.Shirt && sel.style.Shirt.F[3] === "H" )


        

        

        return condition
    } catch(e){

    }
}

export const enableStyleSelection = (sel, value, val1)=>{
    const isJodhPuri = sel.style?.Coat?.F[0][0] === "J" ? true : false;
    
    // Explicit Kurta Neck Placket Single Selection Logic
    if (value.name === "Kurta" && value.type === "Neck Placket") {
        return sel.style?.Kurta?.F?.[1] === val1.value;
    }

    return(
        (sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value && ((value.n !== 0 && value.name === "Coat") || (value.name !== "Coat") ) ) ||
        (value.n === 0 && sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value && ((value.category && value.category !== "tuxedo") || !value.category) && (!sel.tuxedo || isJodhPuri) ) ||
        (value.category && value.category === "tuxedo" && "T-"+ sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value && sel.tuxedo)
    )
}

export const getStyleDetails = (sel, category) => {
        try{
            var StylesDets = {}
            const Stylesfilter_to_use = category === "kurta" ? StylesFilter_kurta
                                        : category === "blazer" ? StylesFilter_Blazer
                                        : category === "sadri" ? StylesFilter_kurta
                                        : StylesFilter
            // console.log("coming here in Styles des funct")
            if(sel && sel.style){
                    
                Object.keys(sel["style"]).forEach((t)=>{
                    StylesDets[t] = []
                    Object.keys(sel["style"][t]).forEach((side)=>{
                        
                        var value = null;
                        var img = null;
                        sel["style"][t][side].forEach((val, k)=>{
                            if( (t!=="Shirt") 
                                || (t === "Shirt" && val!= "BASE" && val!="SLEVE")
                                
                            ){
                            
                            var r = null
                            
                            if(t === "Coat" && side === "F" && val[0] === "J"){
                                r = Stylesfilter_to_use.find((filter) => filter.type === "Jodhpuri");
                                console.log("r:", r)
                            } else{
                                r = Stylesfilter_to_use.find((filter) => filter.name === t && filter.pos === side && filter.n === k);
                            }
                            
                            if(!r){
                                return
                            }
                            // console.log(r, side, t)
                            if( checkStyleConditions(sel, r) ){
                                return
                            }
                            // console.log("from inside", r["attr"])
                            for(let i = 0;i<r["attr"].length;i++){
                                if(value){break}
                                if( Array.isArray(r["attr"][i])){
                                    for(let j = 0;j<r["attr"][i].length;j++){
                                        // console.log("of a type:", r["attr"][i][j])
                                        if(r["attr"][i][j]["value"] === val){
                                            value = r["attr"][i][j]["name"]
                                            img = r["attr"][i][j]["img"]
                                            break    
                                        }
                                    }
                                }else{
                                    if(r["attr"][i]["value"] === val){
                                        value = r["attr"][i]["name"]
                                        img = r["attr"][i]["img"]
                                        break
                                    }
                                }
                            }
                            
                            if(value){
                                StylesDets[t].push( {"type":r["type"], "name":value, "img":img})
                            }
                            
                            //  `${r["type"]} : ${value}`
                            value = null
                            }
                        })
                    })
                })

                
            } 
            return StylesDets
        } catch(e){
            console.log(e)
        }
    }

export const addReachus = async(data, type)=>{

    const coll = db.collection('queries');
    await addData(coll, "", data)
}

function uint8ToBase64(uint8) {
  return btoa(String.fromCharCode.apply(null, uint8));
}

// Utility: Convert base64 back to Uint8Array
function base64ToUint8(base64) {
  const binary = atob(base64);
  const uint8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    uint8[i] = binary.charCodeAt(i);
  }
  return uint8;
}

function base64UrlSafeEncode(uint8Array) {
  return btoa(String.fromCharCode.apply(null, uint8Array))
    .replace(/\+/g, '-')  // Replace + with -
    .replace(/\//g, '_')  // Replace / with _
    .replace(/=+$/, '');  // Remove trailing =
}

function base64UrlSafeDecode(base64) {
  base64 = base64
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  // Pad with '=' to make it valid base64 length
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }

  const binary = atob(base64);
  const uint8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    uint8[i] = binary.charCodeAt(i);
  }
  return uint8;
}

export const encodeObj = (data)=>{
    let D = ""
    if (typeof data === 'string' || data instanceof String){
        D = data
    } else {
        D = JSON.stringify(data)
    }
    const deflated = pako.deflate(D);
    // const base64 = uint8ToBase64(deflated);
    return base64UrlSafeEncode(deflated);

      
    // return compress(strToU8(D));
}

export const decodeObj = (base64)=>{
    return JSON.parse(pako.inflate(base64UrlSafeDecode(base64), { to: 'string' }));
    // return JSON.parse(u8ToStr(decompress(data)))
}

export function categorizeHexColor(hex) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Convert short hex to full hex
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Convert hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate brightness for black/white/gray detection
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Categorize neutral tones
    if (brightness < 50) return 'black';
    if (brightness > 230) return 'white';
    if (Math.abs(r - g) < 10 && Math.abs(r - b) < 10 && Math.abs(g - b) < 10) return 'gray';

    // Convert RGB to HSV for color-based classification
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let hue = 0;

    if (delta !== 0) {
        if (max === r) {
            hue = ((g - b) / delta) % 6;
        } else if (max === g) {
            hue = (b - r) / delta + 2;
        } else {
            hue = (r - g) / delta + 4;
        }
        hue = Math.round(hue * 60);
        if (hue < 0) hue += 360;
    }

    // Hue-based categorization
    if (hue >= 0 && hue < 15) return 'red';
    if (hue >= 15 && hue < 45) return 'orange';
    if (hue >= 45 && hue < 70) return 'yellow';
    if (hue >= 70 && hue < 170) return 'green';
    if (hue >= 170 && hue < 255) return 'blue';
    if (hue >= 255 && hue < 320) return 'purple';
    if (hue >= 320 && hue <= 360) return 'red'; // red wraps around

    return 'gray'; // fallback
}

export function extractUniqueFabricAttributes(fabric) {
    const Pattern = new Set();
    const Color = new Set();
    const Material = new Set();
    const Ocassion = new Set();
    const Brand = new Set();

    for (const clothType in fabric) {
        const items = fabric[clothType];
        items.forEach(item => {
            if (item.pattern) Pattern.add(item.pattern.toLowerCase());
            if (item.material) Material.add(item.material.toLowerCase());
            if (item.ocassion) Ocassion.add(item.ocassion.toLowerCase());
            if (item.brand) Brand.add(item.brand.toLowerCase());

            if (Array.isArray(item.colorCode)) {
                item.colorCode.forEach(code => {
                    Color.add(categorizeHexColor(code.toLowerCase()));
                });
            }
        });
    }

    return {
        Pattern: {attrs: Array.from(Pattern), q : 0},
        Color: {attrs : Array.from(Color), q : 1},
        Material: {attrs : Array.from(Material), q : 0},
        Ocassion: {attrs : Array.from(Ocassion), q : 0},
        Brand : {attrs : Array.from(Brand), q:0}
        // fabricType : {attrs : [], q : 0}
    };
}

export const calPrice = (a)=>{  
        let p = 0
        let D = Number(0)
        Object.keys(a["fabric"]).forEach((element)=>{
            if(a["fabric"][element]["discount"]){
                const perc = Number(a["fabric"][element]["discount"])
                D = D + (Number(a["fabric"][element]["price"])*( perc/100 ) )
            }
            p+=Number(a["fabric"][element]["price"])
        }) 

        return [p, D]
    }

export function applyFilters(products, filters, clothList, sel, getStyleImg, category) {
  let filtered = [...products];

  if (filters && filters.Color && filters.Color.length > 0) {
    filtered = filtered.filter(product =>
      product.colorCode.some(color => filters.Color.includes(categorizeHexColor(color.toLowerCase())))
    );
  }

  if (filters && filters.Material && filters.Material.length > 0) {
    filtered = filtered.filter(product =>
      filters.Material.includes(product.material.toLowerCase())
    );
  }

  if (filters && filters.fabricType && filters.fabricType.length > 0) {
    filtered = filtered.filter(product =>
      filters.fabricType.includes(product.fabricType.toLowerCase())
    );
  }

  if (filters && filters.Pattern && filters.Pattern.length > 0) {
    filtered = filtered.filter(product =>
      filters.Pattern.includes(product.pattern.toLowerCase())
    );
  }

  if (filters && filters.Brand && filters.Brand.length > 0) {
    filtered = filtered.filter(product =>
      filters.Brand.includes(product.brand.toLowerCase())
    );
  }

  if (filters.sortBy === "highToLow") {
    filtered.sort((a, b) => Number(b.price) - Number(a.price));
  } else {
    filtered.sort((a, b) => Number(a.price) - Number(b.price));
  }
  const ids=  []
  filtered.map((vals)=>{ids.push(vals.id)})

  let filteredList = {...clothList}

  Object.keys(filteredList).map((k)=>{
    const x = filteredList[k].filter(vals => ids.includes(vals.fabricID))
    if(x.length > 0){
        filteredList[k] = x
    }
    
    filteredList[k].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  })

// console.log("Filtered List", filteredList)
const fabricIdSets = Object.values(filteredList)
  .map(arr => new Set(arr.map(item => item.fabricID)));

let commonFabricId = null;
if (fabricIdSets.length > 0) {
  // Take the first set and check which fabricID is present in all sets
  for (let fabricId of fabricIdSets[0]) {
    if (fabricIdSets.every(set => set.has(fabricId))) {
      commonFabricId = fabricId;
      break;
    }
  }
}

  if(sel){
    var updatedSel = {...sel}
    console.log("Updated Sel", updatedSel, "filteredList", filteredList, "commonFabricId", commonFabricId);

    sel.types.forEach((ele)=>{
        if((ele !== "Shirt" && category === "Suit") || category !== "Suit"){

            var value_ele;
            const def_fabs = commonFabricId
            value_ele =  filteredList[ele].filter(e=>e.fabricID === def_fabs)

            if(!value_ele.length){value_ele = filteredList[ele][0]}
            else { value_ele = value_ele[0] }

            console.log(ele, "value_ele", value_ele)
            updatedSel = {...updatedSel, 
            ...{
            "fabric":{
            ...updatedSel["fabric"], 
            ...{[ele]:{"fabric":value_ele.fabric, "fabricImg":value_ele.fabricImg, 
            "brand":value_ele.brand, "price": value_ele.price, "src":value_ele.src, "pos":Types[category][ele],
            "single":value_ele["single"], "style":value_ele["style"], "id":value_ele["id"], "fabricID":value_ele["fabricID"], "discount":value_ele["discount"], "brandImg" : value_ele["brandImg"]
            }}
            }
            }}
        }
    })
    console.log("Updated Sel after filter", updatedSel)
    const price = calPrice(updatedSel)
    // setStylesAll({
    //     "Coat":{},
    //     "Vest":{},
    //     "Shirt":{},
    //     "Pant":{}
    // })
    // // console.log("--------UPDATING FABRIC", updatedSel)

    getStyleImg({...updatedSel, ...{"price":price[0], "discount":price[1]}}, 1)
    }
    



  return filteredList;
}

export const filterPresets = (presets, filters, priceToggle, customizeToggle) =>{
    try{
        let filteredPresets = {...presets};
        Object.keys(presets).forEach((key)=>{
            let filtered = [...presets[key]];
            if (filters && filters.Pattern && filters.Pattern.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "pattern", filters.Pattern)
                );
            }
            if (filters && filters.Occasion && filters.Occasion.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "ocassion", filters.Occasion)
                );
            }

            if (filters && filters.Material && filters.Material.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "material", filters.Material)
                );
            }

            if (filters && filters.Type && filters.Type.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "type", filters.Type)
                );
            }

            if (filters && filters.Color && filters.Color.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "colorCode", filters.Color, 1)
                );
            }
            filteredPresets[key] = filtered;
            if (filtered.length === 0) {
                delete filteredPresets[key];
            }
        });
        
        
        
        Object.keys(filteredPresets).forEach((key) => {
            filteredPresets[key].sort((a, b) => {
            if (priceToggle) {
                return Number(a.price) - Number(b.price); // Low to High
            } else {
                return Number(b.price) - Number(a.price); // High to Low
            }
            });
        });

        if(customizeToggle){
            Object.keys(filteredPresets).forEach((key) => {
                filteredPresets[key] = filteredPresets[key].filter(preset => preset.customize);
            });
        }
        

        return filteredPresets;
    } catch(e){
        console.log("Error in filterPresets", e)
    }
}

function selectFromFilter(preset, col, values, type = 0){
    try{
        let selected  = false;
        const values_l = values.map((v)=>v.toLowerCase());
        if(!type){
            preset.fabrics.forEach((fabric)=>{
                if(fabric[col] && values_l.includes(fabric[col].toLowerCase())){
                    selected = true;
                    return;
                }
            })
        }
        else {
            preset.fabrics.forEach((fabric)=>{
                const colors = fabric.colorCode.map((c)=>categorizeHexColor(c.toLowerCase()));
                colors.forEach((c)=>{
                    if(c && values_l.includes(c.toLowerCase())){
                        selected = true;
                        return;
                    }
                })
                if(selected) { return; }
            })
        }
        
        return selected;
    } catch(e){
        console.log("Error in selectFromFilter", e)
    }
}

export const getPresetFilters = (presets)=>{

    try{
        const filters = {
            Pattern: {attrs: [], q : 0},
            Color: {attrs : [], q : 1},
            Material: {attrs : [], q : 0},
            Occasion: {attrs : [], q : 0},
            fabricType : {attrs : [], q : 0},
            Type : {attrs : [], q : 0}
        };

        Object.keys(presets).forEach((key)=>{

            presets[key].forEach((preset)=>{
                preset.fabrics.forEach((fabric)=>{
                    if(fabric.pattern && !filters.Pattern.attrs.includes(fabric.pattern.toLowerCase())){
                        filters.Pattern.attrs.push(fabric.pattern.toLowerCase());
                    }
                    if(fabric.material && !filters.Material.attrs.includes(fabric.material.toLowerCase())){
                        filters.Material.attrs.push(fabric.material.toLowerCase());
                    }
                    if(fabric.ocassion && !filters.Occasion.attrs.includes(fabric.ocassion.toLowerCase())){
                        filters.Occasion.attrs.push(fabric.ocassion.toLowerCase());
                    }
                    if(fabric.type && !filters.Type.attrs.includes(fabric.type.toLowerCase())){
                        filters.Type.attrs.push(fabric.type.toLowerCase());
                    }
                    if(Array.isArray(fabric.colorCode)){
                        fabric.colorCode.forEach((color)=>{
                            const categorizedColor = categorizeHexColor(color.toLowerCase());
                            if(categorizedColor && !filters.Color.attrs.includes(categorizedColor)){
                                filters.Color.attrs.push(categorizedColor);
                            }
                        });
                    }
                });
            });
        })

        Object.keys(filters).forEach((key)=>{
            if(filters[key].attrs.length === 0){
                delete filters[key];
            }
        })
            

        return filters;
    } catch(e){
        console.log("Error in getPresetFilters", e)
    }
}

export const getCoatLayers = (side, ref, ref_buttons, name, obj, ref_tuxedo)=>{

    try {

    

    const L = name.split("-");
    const isJodhpur = obj.style.Coat.F[0][0] === "J" ? true : false;
    const isStitch = obj.style.Coat.F[-1] === "Y" ? true : false;
    const bottom_pocket = obj.style.Coat.F[2];
    const isTuxedo = obj.tuxedo && Object.keys(obj.tuxedo).length > 0 && !isJodhpur ? true : false;

    if(side === "F"){
        let buttons = 0;
        let lapel = 0;
        let b_p = 0;
        let u_p = 0;
        let stitch = false;

        
        buttons = L[0];
        lapel = L[1];
        b_p = L[2];
        u_p = L[3];
        stitch = L[4] === "Y" ? true : false;
        const Layers = [
            {
                "name": isJodhpur ? buttons : (buttons[0] === "6" ? "4B": buttons) 
                    + "-" 
                    + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel)
                    + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "base"
            },
            {
                "name": "BC-" + (isJodhpur ? "JH" : buttons) + "-F",
                "col": ref_buttons,
                "types" : ["display"],
                "layer" : "button_display",
                "fromStyle" : true
            },
            {
                "name": "BC-" + (isJodhpur ? "JH" : buttons) + "-S",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "button_style"
            },
            {
                "name":isJodhpur ? "BJH-" + b_p : "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "bottom_pocket"
            },
            {
                "name": isJodhpur ? "UJH-" + u_p : "UP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + u_p + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "upper_pocket"
            },
            {
                "name":  (isJodhpur || isTuxedo) ? "0" :
                    "L" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" 
                    + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel)
                    + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "default_lapel"
            },
            {
                "name": (lapel === "S" || isJodhpur) ? "0" : "C" + (buttons[0] === "6" ? "4" : buttons[0]) + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "default_collar"
            },
            {
                "name": isJodhpur ? "BJH-" + b_p + (stitch ? "-Y" : "-N") : "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + (stitch ? "-Y" : "-N")   ,
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "shadow_bottom_pocket"
            },
            {
                "name": "BCS-S",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "coat_sleeve_button"
            },
        ]

        if(isTuxedo){
            Layers.push({
                "name": "TB-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_base",
                "fromStyle": true
            });
            Layers.push({
                "name": "TB-" + (buttons[0] === "6" ? "4B" : buttons) 
                + "-" 
                + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel) 
                + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_base_2nd",
            });

            Layers.push({
                "name": "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_bottom_pocket",
                "fromStyle": true
            });
            Layers.push({
                "name": "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_bottom_pocket_2nd"
            });

            Layers.push({
                "name": lapel === "S" ? "0" : "TC-" + (buttons[0] === "6" ? "4B" : buttons) + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_collar",
                "fromStyle": true
            });
            Layers.push({
                "name": lapel === "S" ? "0" : "TC-" + (buttons[0] === "6" ? "4B" : buttons) + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_collar_2nd"
            });
        }

        return Layers;
    } else {
        const Layers =  [
            {
                "name": isJodhpur ? "JH-" + L[0] : L[0],
                "col": ref,
                "types" : ["style"],
                "layer" : "base"
            },
            {
                "name":  isJodhpur? "0" : "BC-" + (isStitch ? "Y" : "N"),
                "col": ref,
                "types" : ["style"],
                "layer" : "base_collar"
            },
            {
                "name":  "BP-" + bottom_pocket + (isStitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style"],
                "layer" : "bottom_pocket"
            },
            {
                "name":  "S-BP-" + bottom_pocket,
                "col": ref,
                "types" : ["style"],
                "layer" : "shadow_bottom_pocket"
            },
            {
                "name":  "BCS-B",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "base_sleeve_button"
            }
        ]
        if(isTuxedo){
            Layers.push({
                name : "TCB",
                col: ref_tuxedo,
                types : ["style"],
                layer : "tuxedo_collar_back"
            })
            Layers.push({
                name : "BP-F-B",
                col: ref_tuxedo,
                types : ["style"],
                layer : "tuxedo_bottom_pocket"
            })

        }

        return Layers;

    } 
    } catch(e){
        console.log("Error in getCoatLayers", e)
    }
}
// jodhpuri back extra collar
// jpdhpuri upper pocklet
// saul lapel embriodery collar in normal suit

export const getVestLayers = (side, ref, ref_buttons, name, obj, ref_tuxedo)=>{
    try {
        const Layers = [];

        const isTuxedo = obj.tuxedo && Object.keys(obj.tuxedo).length > 0 ? true : false;
        Layers.push({
            "name": name,
            "col": ref,
            "types" : ["style", "display"],
            "layer" : "base"
        });
        Layers.push({
            "name": "B" + name + "-S",
            "col": ref_buttons,
            "types" : ["style"],
            "layer" : "button_style"
        });
        if(isTuxedo){
            Layers.push({
                "name": "TV" + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_base",
                "fromStyle": true
            });
            Layers.push({
                "name": "TV" + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_base_2nd",
                "fromStyle": true
            });
        }

        return Layers;
    } catch(e){
        console.log("Error in getVestLayers", e)
    }

}

export const getOrderedButtons = (sel, Buttons, valueName) => {
    let buttonsOrder = [];
    let buttonsOrderIds =[];

    if (sel.fabric[valueName]["recommended_buttons"]){
        sel.fabric[valueName]["recommended_buttons"].forEach(element => {
            const butt = Buttons.filter((e)=> e.id === element)
            console.log("butt", butt);
            if(butt.length){
                buttonsOrder.push(butt[0]);
                buttonsOrderIds.push(butt[0].id);
            }
        });
    }


    buttonsOrder = [...buttonsOrder, ...Buttons.filter((e)=> !buttonsOrderIds.includes(e.id))];
    console.log("buttons order", buttonsOrder);
    return buttonsOrder;
}

export const setEmbroideryImages = async(Obj, category)=>{

    try{

        let sel = {...Obj}

        const embs = sel["embroidery"]
        for(let i=0;i<embs.length;i++){
            const values =  embs[i].values
            if(values){
                for(let j = 0;j<values.length;j++){
                    const docRef = db.collection("Fabric").doc("embroidery").collection(values[j].type).doc(values[j].id)

                    const data = await getDatafromDoc(docRef)
                    
                    const fileNames = getFileNamesFromType( values[j].type, sel )

                    fileNames.forEach((name)=>{
                        if(name.type === "display"){
                            if(data["resources"][name.name]){
                                if(Object.hasOwn(name, "pos")){
                                    sel.fabric.Coat.src.splice(name.pos, 0, data["resources"][name.name])
                                } else {
                                    sel.fabric.Coat.src.push(data["resources"][name.name])
                                }
                            } else {
                                console.log("Embroidery not found for ", name.name)
                            }
                        }
                        if(name.type === "style"){

                            if(data["resources"][name.name]){
                                if(Object.hasOwn(name, "pos")){
                                    sel.fabric.Coat.single[0].src.splice(name.pos, 0, data["resources"][name.name])
                                } else {
                                    sel.fabric.Coat.single[0].src.push(data["resources"][name.name])
                                }
                            } else {
                                console.log("Embroidery not found for ", name.name)
                            }
                        }
                        if(name.type === "back"){
                            if(data["resources"][name.name]){
                                if(Object.hasOwn(name, "pos")){
                                    sel.fabric.Coat.single[1].src.splice(name.pos, 0, data["resources"][name.name])
                                } else {
                                    sel.fabric.Coat.single[1].src.push(data["resources"][name.name])
                                }
                            } else {
                                console.log("Embroidery not found for ", name.name)
                            }
                        }
                    })
                }
            }
        }

        return sel;


    } catch(e){
        console.log("from emboridery image retrival", e);
    }

}

export const getCollectionNamesFromCategory = (category)=>{
    let coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;
    return coll;
}

export const getFileNamesFromType = (type, sel)=>{
    try{
        switch(type){
            case "coat_base":
                return CoatBaseEmbNames(sel);
            case "coat_collar":
                return CoatCollarEmbNames(sel);
            case "Coat_lapel":
                return CoatLapelEmbNames(sel);
            case "Coat_sleeve":
                return CoatBaseSleeveEmbNames(sel);
            default:
                return []
        }
    } catch(e){
        console.log("getFileNamesFromType ", e)
    }
}

const CoatBaseEmbNames = (obj)=>{
    try {
        const buttons = obj.style.Coat.F[0];

        if(buttons[0] === "J"){
            return [ 
                    {
                        name : "E"+ buttons + "-S",
                        type : "style",
                        pos : 1
                    },
                    {
                        name : "E"+ buttons + "-F" ,
                        type : "display",
                        pos : 1
                    }
                ]
        } else {
            return [ 
                    {
                        name : "EB" + (buttons[0] === "6" ? "4" : buttons[0]) + "-S",
                        type : "style",
                        pos : 1
                    },
                    {
                        name : "EB" + (buttons[0] === "6" ? "4" : buttons[0]) + "-F" ,
                        type : "display",
                        pos : 1
                    }
                ]
        }


    } catch(e){
        console.log("CoatBaseEmbNames ", e)
    }
}

const CoatBaseSleeveEmbNames = (sel) =>{
    try {
        return [
            {
                name : "ES-S",
                type : "style",
                pos : 1
            },
            {
                name : "ES-F" ,
                type : "display",
                pos : 1
            },
            {
                name : "ES-B" ,
                type : "back",
                pos : 1
            }
        ]
    } catch(e){
        console.log("CoatBaseSleeveEmbNames  ", e)
    }
}

const CoatLapelEmbNames = (obj)=>{
    try {
        const buttons = obj.style.Coat.F[0];
        const lapel = obj.style.Coat.F[1];

        if(buttons[0] == "J"){
            return []
        } else {
            return [
                {
                    name: "EL-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-F",
                    type : "display"
                },
                {
                    name: "EL-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-S",
                    type : "style"
                }
            ]
        }
        

    } catch(e){
        console.log("CoatLapelEmbNames  ", e)
    }
}

const CoatCollarEmbNames = (obj)=>{
    try {   
        const buttons = obj.style.Coat.F[0];

        return [
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-F", 
                type : "display"
            },
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-S", 
                type : "style"
            },
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-B", 
                type : "back"
            }
        ]

    } catch(e){
        console.log("CoatCollarEmbNames  ", e)
    }
}

export const isEmbEnabled = (category)=>{
    if(category === "suit" || category === "blazer"){
        return true
    }
    return false;
}

// try {

// } catch(e){
//     console.log("  ", e)
// }

export const getRowsFromArray = (arr, itemsPerRow, currIndex) => {
    if(!arr || !Array.isArray(arr) || arr.length === 0 || currIndex % itemsPerRow !== 0){
        return [];
    }

    if(currIndex === 0 || currIndex%itemsPerRow === 0){
        return arr.slice(currIndex, currIndex + itemsPerRow);
    }
    return [];
}